<script>
    import { getNewIcon } from "../../card_images";
	import "../shared.css";

	export let awayTeams;
	export let isBorg = false;

	let icon;
	$: label = awayTeams.toString();
	$: icon = isBorg ? 'drone' : 'away team';
	$: bgColor = isBorg ? '#0d853d' : '#114e8a';
	$: letterSpacing = label.length > 1 ? 'calc(0px - var(--width) / 57.4)' : 'auto'; //'-5px' : 'auto';
</script>

<div class="at-badge">
	<img src={getNewIcon(icon)} />
	<div class="count" style="--bgc:{bgColor}">
		<span class="font-block" style="--spacing:{letterSpacing}">{label}</span>
	</div>
</div>

<style lang="scss">
	.at-badge {
		padding-left: calc(var(--height) / 28.643); //14px;
		width: fit-content;
		flex-direction: column;
		align-items: center;
		& > :global(img) {
			width: 2.2em;
			z-index: 3;
		}
	}
	.count {
		width: 1.8em;
		height: 2.25em;
		background-color: var(--bgc);
		z-index: 0;
		margin-top: calc(0px - var(--height) / 26.733); //-15px;
		align-items: flex-end;
		justify-content: center;
		padding-bottom: 0px;
		border-radius: 0 0 calc(var(--height) / 100.25) calc(var(--height) / 100.25); //0 0 4px 4px;
		& > span {
			color: white;
			font-size: calc(var(--height) / 18.227); //22px;
			line-height: 1.1;
			letter-spacing: var(--spacing);
		}
	}
</style>
